import { resetAttribute, getTreeArray, sortArray } from '@/utils/handleData.js'
import {
  collectIndexUpdates,
  findParentNode
} from '@/utils/pageIndex.js'
import { stripRemovedAppletPages } from '@/utils/platformPages'

const SORT_UP_BUTTON_INDEX = 2
const SORT_DOWN_BUTTON_INDEX = 3

const getAllPages = (data) => {
  data.forEach((item) => {
    if (item.meta) {
      item.icon = item.meta.icon
    }
    if (item.children && item.children.length) {
      item.children = getAllPages(item.children)
    }
  })
  return data
}

const markSortButtons = (list) => {
  if (!list || !list.length) return list
  list.forEach((item, i) => {
    const disabled = []
    if (i === 0) disabled.push(SORT_UP_BUTTON_INDEX)
    if (i === list.length - 1) disabled.push(SORT_DOWN_BUTTON_INDEX)
    item.disabledButtons = disabled
    if (item.children && item.children.length) {
      markSortButtons(item.children)
    }
  })
  return list
}

const findSiblingList = (tree, uid) => {
  if (!tree || !tree.length) return null
  const matched = tree.find((item) => item.pageUid === uid || item.uid === uid)
  if (matched) return tree
  for (let i = 0; i < tree.length; i++) {
    const found = findSiblingList(tree[i].children, uid)
    if (found) return found
  }
  return null
}

export default {
  namespaced: true,
  state: {
    allWebPages: [], // 系统所有web端权限页面
    allAppletPages: [] // 系统所有小程序端权限页面
  },
  actions: {
    // 新增web页面
    async addWebPage({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/page/lqconfig',
          data: data,
          msg: '新增web页面成功'
        },
        { root: true }
      )
      return res
    },
    // 获取系统web端所有页面
    async getAllWebPages({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/rule/role/allpage' },
        { root: true }
      )
      // console.log(res)
      var allWebPages =
        res.data && res.data.length
          ? sortArray(res.data, ['index'], ['number'])
          : []
      allWebPages = getAllPages(allWebPages)
      allWebPages = resetAttribute(
        allWebPages,
        'pageName',
        'pageUid',
        'children'
      )
      markSortButtons(allWebPages)
      commit(
        'baseSet',
        { module: 'pages', key: 'allWebPages', value: allWebPages },
        { root: true }
      )
      return allWebPages
    },
    // 编辑web页面
    async editWebPage({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/rule/page/lqconfig',
          data: data,
          msg: '编辑web页面成功'
        },
        { root: true }
      )
      return res
    },
    // 新增Applet页面
    async addAppletPage({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/page/wxconfig',
          data: data,
          msg: '新增App页面成功'
        },
        { root: true }
      )
      return res
    },
    // 获取系统Applet端所有页面
    async getAllAppletPages({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/rule/page/wxconfiglist' },
        { root: true }
      )
      // console.log(res)
      var allAppletPages =
        res.data && res.data.length
          ? sortArray(res.data, ['pageIndex'], ['number'])
          : []
      allAppletPages = getTreeArray(allAppletPages)
      allAppletPages = stripRemovedAppletPages(allAppletPages)
      allAppletPages = resetAttribute(
        allAppletPages,
        'pageName',
        'uid',
        'children'
      )
      markSortButtons(allAppletPages)
      commit(
        'baseSet',
        { module: 'pages', key: 'allAppletPages', value: allAppletPages },
        { root: true }
      )
      return allAppletPages
    },
    // 编辑Applet页面
    async editAppletPage({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/rule/page/wxconfig',
          data: data,
          msg: '编辑App页面成功'
        },
        { root: true }
      )
      return res
    },
    async sortPages({ dispatch }, payload) {
      const isWeb = payload.isWeb
      const items = payload.items || []
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        const res = await dispatch(
          'baseRequest',
          isWeb
            ? {
                method: 'PUT',
                url: '/rule/page/lqconfig',
                data: { uid: item.uid, index: item.index }
              }
            : {
                method: 'PUT',
                url: '/rule/page/wxconfig',
                data: { uid: item.uid, pageIndex: String(item.index) }
              },
          { root: true }
        )
        if (!res || res.code !== 200) return res
      }
      await dispatch(isWeb ? 'getAllWebPages' : 'getAllAppletPages')
      return { code: 200 }
    },
    async movePageRow({ state, dispatch }, payload) {
      const isWeb = payload.isWeb
      const uid = payload.uid
      const direction = payload.direction
      const tree = isWeb ? state.allWebPages : state.allAppletPages
      const indexKey = isWeb ? 'index' : 'pageIndex'
      const siblings = findSiblingList(tree, uid)
      if (!siblings || siblings.length < 2) {
        return { code: 400, msg: '当前层级没有可调整的相邻页面' }
      }
      const currentIndex = siblings.findIndex(
        (item) => item.pageUid === uid || item.uid === uid
      )
      const targetIndex =
        direction === 'up' ? currentIndex - 1 : currentIndex + 1
      if (currentIndex < 0 || targetIndex < 0 || targetIndex >= siblings.length) {
        return {
          code: 400,
          msg: direction === 'up' ? '已经是同级第一项' : '已经是同级最后一项'
        }
      }
      const ordered = siblings.slice()
      const moved = ordered.splice(currentIndex, 1)[0]
      ordered.splice(targetIndex, 0, moved)
      const parent = findParentNode(tree, uid)
      const items = collectIndexUpdates(
        ordered,
        parent ? Number(parent[indexKey]) : 0,
        !parent,
        indexKey
      )
      if (!items.length) {
        return { code: 200 }
      }
      return dispatch('sortPages', { isWeb: isWeb, items: items })
    }
  }
}
